import React, { useEffect } from 'react';
import styled from 'styled-components';
import Modal from '../Donee/components/common/Modal';
import { Text } from '../Donee/components/common/Text/Text';
import { GivelifyButton } from '../Donee/components/common/Button/GivelifyButton';
import { ErrorInfoIcon } from '../icons';
import { colors } from '../theme';
import { usePaymentOutageContext } from '../../providers/PaymentOutageProvider';
import { usePushEvents } from '../../hooks/PushEvents';
import { paymentOutageModalEvent } from '../../hooks/PushEvents/clevertapEvents';

const StyledDiv = styled.div`
  padding: 40px;
  .error-info-icon {
    padding: 12px;
    margin-top: 24px;
    margin-bottom: 24px;
    border-radius: 100px;
    display: inline-block;
    background-color: ${colors.utilityErrorLightColor};
    svg {
      margin-bottom: -3px;
    }
  }
  .modal-subheading {
    max-width: 295px;
    margin: 16px auto 40px auto;
  }
`;

const PaymentOutage: React.FC = () => {
  const { pushEvent } = usePushEvents();
  const { open, handleClose } = usePaymentOutageContext();

  useEffect(() => {
    if (open) {
      pushEvent(paymentOutageModalEvent);
    }
  }, [open, pushEvent]);

  return (
    <Modal
      active={open}
      onClose={handleClose}
      className="login-modal"
      shouldCloseOnOverlayClick={false}
    >
      <StyledDiv>
        <div className="error-info-icon">
          <ErrorInfoIcon />
        </div>
        <Text weight="bold">
          Your gift failed due to a<br />
          problem on our end
        </Text>
        <Text
          variant="small"
          color="primarySecondaryContent"
          className="modal-subheading"
        >
          Our team is working to fix the issue. Thanks for your patience.
          <br />
          <br />
          We'll email you when your gift can be completed.
        </Text>
        <GivelifyButton onClick={handleClose}>OK</GivelifyButton>
      </StyledDiv>
    </Modal>
  );
};

export default PaymentOutage;
